import {
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogScrollableContent,
  DialogTitle,
  Label,
  Select,
} from "@win-reality/react-ui";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSport } from "../../../store/slices/session";
import { setModalState } from "../../../store/slices/view";
import type { RootState } from "../../../store/store";

const SPORT_OPTIONS = [
  { label: "Baseball", value: "baseball" },
  { label: "Softball", value: "softball" },
];

export const ChangeSportModal = () => {
  const dispatch = useDispatch();
  const { state } = useSelector((state: RootState) => state.view.modalState);
  const currentSport = useSelector((state: RootState) => state.session.sport);
  const [selectedSport, setSelectedSport] = useState<string>(
    currentSport || "baseball",
  );

  useEffect(() => {
    setSelectedSport(currentSport || "baseball");
  }, [currentSport]);

  const handleClose = () => {
    dispatch(setModalState({ state: null, data: {} }));
  };

  const handleSubmit = () => {
    dispatch(setSport(selectedSport));
    dispatch(setModalState({ state: null, data: {} }));
  };

  return (
    <Dialog
      open={state === "Change Sport"}
      onOpenChange={(open) => !open && handleClose()}
      defaultCancelButton={false}
      size="sm"
    >
      {({ showDivider, setScrollContainer }) => (
        <>
          <DialogScrollableContent setScrollContainer={setScrollContainer}>
            <DialogHeader>
              <DialogTitle>Change Sport</DialogTitle>
            </DialogHeader>

            <p className="text-sm text-gray-500">
              Changing sport will update the pitch types and strike zone visual
              only. This does not change the sport configuration on your
              SmartPark.
            </p>

            <div className="flex flex-col gap-4 pt-6">
              <div className="flex flex-col">
                <Label className="text-sm font-medium">Sport</Label>
                <Select
                  items={SPORT_OPTIONS}
                  value={selectedSport}
                  onValueChange={setSelectedSport}
                  placeholder="Select sport"
                />
              </div>
            </div>
          </DialogScrollableContent>

          <DialogFooter showDivider={showDivider}>
            <div className="flex w-full justify-between">
              <Button
                variant="ghost"
                type="button"
                className="underline"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button variant="secondary-flat-light" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
};
